module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5fdb7c093bfefc2c00ef83fd4c34199e.gif";